import { Button, styled } from "@mui/material";
import { IRootState } from "../../redux/root.reducer";
import { useAppSelector } from "../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

const link = process.env.REACT_APP_RETAILSTAT_URL ?? "https://retailstat.com";

const Footer = ({ className }: IWithClassName) => {
    const globalData = useAppSelector(({ global }: IRootState) => global);

    return (
        <div className={className}>
            <div className="link-group">
                <a
                    className="linkedin-button"
                    rel="noreferrer"
                    target="_blank"
                    href={globalData.linkedInUrl}
                >
                    <img src="/assets/LinkedIn.svg" alt="LinkedIn" />
                </a>
                <Button
                    className="contact-button"
                    variant="contained"
                    color="primary"
                    rel="noreferrer"
                    target="_blank"
                    href={`${link}/contact-us`}
                >
                    Contact Us
                </Button>
            </div>
            <div className="text-group">
                <p>{globalData.copyrightText}</p>
                <a
                    className="privacy-link"
                    rel="noreferrer"
                    target="_blank"
                    href={globalData.privacyPolicyUrl}
                >
                    Privacy Policy
                </a>
            </div>
        </div>
    );
};

export default styled(Footer)(({ theme }: IWithThemeProps) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    ".link-group, .text-group": {
        display: "flex",
        alignItems: "center",
    },

    p: {
        padding: theme?.spacing(2),
        fontSize: 16,
        color: theme?.palette.footer.textColor,
    },

    ".contact-button": {
        backgroundColor: theme?.palette.action.active,
        borderRadius: 20,
        textTransform: "uppercase",
        fontSize: 16,
        fontWeight: 600,
        textDecoration: "none",
        padding: theme?.spacing(1, 2),
        color: theme?.palette.background.default,
        marginLeft: theme?.spacing(2),
    },

    ".linkedin-button": {
        marginRight: theme?.spacing(2),
    },

    ".privacy-link": {
        textDecoration: "none",
        color: theme?.palette.action.active,
        fontSize: 16,
        fontWeight: 600,
    },
}));
